module.exports = __webpack_public_path__ + "static/media/1.ebc6a6db.jpg";